(function () {
  'use strict';

  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 180;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 1200px)').matches;
  }

  function LpMegaMenuController(root) {
    this.root = root;
    this.triggers = Array.from(root.querySelectorAll('[data-lp-mega-menu]'));
    this.openTimer = null;
    this.closeTimer = null;
    this.active = null;
    this.bind();
  }

  LpMegaMenuController.prototype.bind = function () {
    var self = this;

    this.triggers.forEach(function (trigger) {
      var details = trigger.querySelector('.details-header-menu.lp-mega-menu');
      if (!details) return;

      var summary = details.querySelector('summary');
      var panel = details.querySelector('[data-lp-mega-menu-panel]');
      var backdrop = panel && panel.querySelector('[data-lp-mega-menu-backdrop]');
      if (!summary || !panel) return;

      trigger._lpMega = { details: details, summary: summary, panel: panel, backdrop: backdrop };

      trigger.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        self.scheduleOpen(trigger);
      });

      trigger.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        self.scheduleClose(trigger);
      });

      panel.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        self.clearTimers();
        if (self.active !== trigger) self.open(trigger, false);
      });

      panel.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        self.scheduleClose(trigger);
      });

      trigger.addEventListener('focusin', function () {
        if (!isDesktop()) return;
        self.scheduleOpen(trigger);
      });

      summary.addEventListener('click', function (event) {
        if (!isDesktop()) return;
        event.preventDefault();
        if (self.active === trigger) self.close(trigger, true);
        else self.open(trigger, true);
      });

      summary.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          if (!isDesktop()) return;
          event.preventDefault();
          if (self.active === trigger) self.close(trigger, true);
          else self.open(trigger, true);
        }
      });

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          self.close(trigger, true);
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.active) {
        self.close(self.active, true);
      }
    });

    document.addEventListener('click', function (event) {
      if (!self.active || !isDesktop()) return;
      if (self.active.contains(event.target)) return;
      self.close(self.active, true);
    });

    window.addEventListener('resize', function () {
      if (!isDesktop() && self.active) self.close(self.active, true);
    });
  };

  LpMegaMenuController.prototype.clearTimers = function () {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    this.openTimer = null;
    this.closeTimer = null;
  };

  LpMegaMenuController.prototype.scheduleOpen = function (trigger) {
    var self = this;
    clearTimeout(this.closeTimer);
    this.closeTimer = null;
    clearTimeout(this.openTimer);
    this.openTimer = setTimeout(function () {
      self.open(trigger, false);
    }, prefersReducedMotion() ? 0 : OPEN_DELAY);
  };

  LpMegaMenuController.prototype.scheduleClose = function (trigger) {
    var self = this;
    clearTimeout(this.openTimer);
    this.openTimer = null;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(function () {
      if (self.active === trigger) self.close(trigger, false);
    }, prefersReducedMotion() ? 0 : CLOSE_DELAY);
  };

  LpMegaMenuController.prototype.open = function (trigger) {
    this.clearTimers();

    if (this.active && this.active !== trigger) {
      this.close(this.active, true);
    }

    var parts = trigger._lpMega;
    if (!parts) return;

    this.active = trigger;
    parts.details.classList.add('is-lp-open');
    parts.details.setAttribute('open', '');
    parts.summary.setAttribute('aria-expanded', 'true');
    parts.panel.hidden = false;
    parts.panel.classList.add('is-open');

    var header = this.root.closest('.section-header');
    if (header) header.classList.add('header--is-active');

    parts.panel.querySelectorAll('a[tabindex="-1"]').forEach(function (el) {
      el.setAttribute('tabindex', '0');
    });
  };

  LpMegaMenuController.prototype.close = function (trigger) {
    this.clearTimers();
    if (!trigger || !trigger._lpMega) return;

    var parts = trigger._lpMega;
    parts.details.classList.remove('is-lp-open');
    parts.details.removeAttribute('open');
    parts.summary.setAttribute('aria-expanded', 'false');
    parts.panel.classList.remove('is-open');
    parts.panel.hidden = true;

    parts.panel.querySelectorAll('[data-lp-mega-menu-card]').forEach(function (el) {
      if (el.tagName === 'A') el.setAttribute('tabindex', '-1');
    });

    if (this.active === trigger) this.active = null;

    var anyOpen = this.triggers.some(function (t) {
      return t._lpMega && t._lpMega.details.classList.contains('is-lp-open');
    });
    var header = this.root.closest('.section-header');
    if (header && !anyOpen) header.classList.remove('header--is-active');
  };

  LpMegaMenuController.prototype.closeAll = function () {
    var self = this;
    this.triggers.forEach(function (trigger) {
      self.close(trigger, true);
    });
  };

  function boot(scope) {
    var root = scope || document;
    var header = root.querySelector ? root.querySelector('.section-header') : null;
    if (!header) return;

    if (header._lpMegaMenuController) {
      header._lpMegaMenuController.closeAll();
      return;
    }

    if (!header.querySelector('[data-lp-mega-menu]')) return;
    header._lpMegaMenuController = new LpMegaMenuController(header);
  }

  boot();

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-lp-mega-menu]')) boot(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.hasAttribute('data-shopify-editor-block')) return;
    var panel = block.closest('[data-lp-mega-menu-panel]');
    if (!panel) return;
    var details = panel.closest('.details-header-menu.lp-mega-menu');
    var trigger = details && details.closest('[data-lp-mega-menu]');
    var header = panel.closest('.section-header');
    if (header && header._lpMegaMenuController && trigger) {
      header._lpMegaMenuController.open(trigger);
    }
  });

  document.addEventListener('shopify:block:deselect', function () {
    var header = document.querySelector('.section-header');
    if (header && header._lpMegaMenuController) header._lpMegaMenuController.closeAll();
  });
})();
